import React, { useState } from 'react';

import { type SxProps, Tab, Tabs as TabsBase } from '@mui/material';

type TTab = {
  label: string;
  panel: JSX.Element;
  sx?: SxProps;
};
type Props = {
  tabs: TTab[];
};

export default function Tabs({ tabs }: Props) {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  return (
    <>
      <TabsBase
        value={currentTabIndex}
        onChange={(_, value) => setCurrentTabIndex(value)}
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        {tabs.map((t, i) => (
          <Tab key={i} label={t.label} value={i} sx={t.sx} />
        ))}
      </TabsBase>

      {tabs[currentTabIndex].panel}
    </>
  );
}
